import Button from '@atlaskit/button/new';

import type { Action } from '../../../common/types';
import { useRovoDevWebAnalyticsClient } from '../../../controllers/rovo-dev-web-analytics-events';

export const DefaultActionButton = ({ act }: { act: Action }) => {
	const { label, icon, action, analyticEvent } = act;
	const { fireUiEvent } = useRovoDevWebAnalyticsClient();

	const handleClick = () => {
		if (analyticEvent) {
			fireUiEvent(analyticEvent);
		}
		if (action) {
			action();
		}
	};

	return (
		<Button
			appearance="subtle"
			iconAfter={icon}
			onClick={handleClick}
			spacing="compact"
			testId={act.testId ? act.testId : undefined}
		>
			{label}
		</Button>
	);
};
